
export function hasPostMessageError(obj: any): boolean {
    return obj?.error === true;
}